module.exports = __webpack_public_path__ + "static/media/da-ct-scan-4.b7be6d1b.jpg";